var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"fs"},on:{"click":_vm.fs}},[_c('img',{attrs:{"src":_vm.srcFs,"alt":"Plein-écran"}})])}
var staticRenderFns = []

export { render, staticRenderFns }